import flattenObject from "../utils/flattenObject";

export default flattenObject({
    errors: {
        errorCreatingPayment:
            "<b>Errore durante la creazione del pagamento:</b> si prega di riprovare più tardi",
        errorSettingAlreadyPaid:
            "<b>Errore durante il salvataggio del pagamento già effettuato:</b> si prega di riprovare più tardi",
        errorDownloadingDocument:
            "<b>Errore durante il download del documento:</b> si prega di riprovare più tardi",
        errorGettingDocumentPreview:
            "<b>Errore durante il recupero dell'anteprima del documento:</b> si prega di riprovare più tardi",
        errorDownloadingReceipt:
            "<b>Errore durante il download della ricevuta:</b> si prega di riprovare più tardi",
    },
    components: {
        AlreadyPaidModal: {
            title: "Conferma pagamento effettuato",
            line1: "Confermi di aver già effettuato il pagamento dell'intero importo?",
            line2: "Il creditore verrà notificato con una email.",
            noteForCreditor: "Nota per il creditore:",
            abort: "Annulla",
            confirm: "Conferma",
        },
        DocumentsPreviewer: {
            modalTitle: "Documenti",
            download: "Scarica",
            downloadBoundToPayment:
                "Potrai scaricare il documento solo dopo aver concluso il pagamento.",
            errorLoadingPreview: "Si è verificato un errore.",
            Toolbar: {
                page: "Pagina:",
                of: "di {totalPages}",
            },
        },
        Header: {
            paymentRequestByCreditor: "Richiesta di pagamento da parte di",
        },
        LanguageSelect: {
            italian: "Italiano",
            ita: "ITA",
            english: "Inglese",
            eng: "ENG",
            modal: {
                title: "Seleziona la lingua",
                confirm: "Conferma",
            },
        },
        PaymentAlreadyExistModal: {
            title: "Conferma operazione",
            line1: "E' stata già avviata una sessione di pagamento che coinvolge una o più delle soluzioni di pagamento selezionate.",
            line2: "Avviando questa sessione di pagamento verrà disabilitata la precedente sessione.",
            abort: "Annulla",
            proceed: "Procedi",
        },
        PaymentConfirmedSummary: {
            thankYou: "GRAZIE!",
            paymentSucceeded: "PAGAMENTO CONCLUSO CON SUCCESSO!",
            paymentConfirmed: "PAGAMENTO CONFERMATO CON SUCCESSO!",
            summary: "RIEPILOGO OPERAZIONE",
            onBehalfOf: "TeamSystem Payments S.r.l. per conto di {companyName}",
            installment: "Rata {installmentNumber}",
            abbreviatedInstallment: "Rata {installmentNumber}",
            showInstallments: "Mostra rate",
            paymentReason: "Causale pagamento",
            bankTransfer: "Conto corrente",
            creditOrDebitCard: "Carda di credito/debito",
            iban: "IBAN ****************{iban}",
            creditCard: "{cardName} **** **** **** {pan}",
            deadline: "Scadenza:",
            singleScheduledTooltip: "L'addebito verrà effettuato alla scadenza",
            paymentInfo:
                "L'addebito sarà visibile nel tuo estratto conto come <i>Teamsystem Pay</i>",
            goBackToPaymentRequest: "Torna alla richiesta di pagamento",
            downloadPaymentReceipt: "Scarica ricevuta di pagamento",
            downloadReceipt: "Scarica ricevuta",
            modal: {
                title: "Pagamento a rate",
                close: "Chiudi",
                total: "Totale",
            },
        },
        PaymentFailedSummary: {
            operationRefused: "Operazione rifiutata",
            paymentFailed: "Il pagamento non è andato a buon fine!",
            summary: "RIEPILOGO OPERAZIONE",
            onBehalfOf: "TeamSystem Payments S.r.l. per conto di {companyName}",
            paymentReason: "Causale pagamento",
            error: "Errore",
            goBackToRequestInfo:
                "Torna alla richiesta per effettuare un nuovo pagamento.",
            goBackToPaymentRequest: "Torna alla richiesta di pagamento",
        },
        PaymentFailedModal: {
            title: "Pagamento fallito",
            line1: "Il pagamento non è andato a buon fine.",
            line2: "La richiesta di pagamento risulta ancora da pagare. Effettua un nuovo pagamento entro la data di scadenza.",
            error: "Errore n. {number}",
            installment: "Rata",
            total: "Totale",
            confirm: "Ho capito",
        },
        PayNowModal: {
            payNowTitle: "Pagamento immediato",
            payOnDeadlineTitle: "Pagamento alla scadenza",
            payNowLine1:
                "Hai scelto il <b>pagamento immediato</b> come soluzione di pagamento.",
            payNowLine2:
                "Ti verrà addebitato il totale a pagare al momento del pagamento.",
            payOnDeadlineLine1:
                "Hai scelto il <b>pagamento alla scadenza</b> come soluzione di pagamento.",
            payOnDeadlineLine2:
                "Ti verrà addebitato il totale a pagare il giorno della scadenza.",
            expiredInstallmentsInfo:
                "Gli importi scaduti ti verranno addebitati entro 24 ore.",
            confirm: "Ho capito",
        },
        PaymentSolutionsModal: {
            paySingleInstallmentPlanOnDeadlineTitle: "Pagamento alla scadenza",
            payMultipleInstallmentsPlanOnDeadlineTitle: "Pagamento a rate",
            payNowTitle: "Paga subito",
            paySingleInstallmentPlanOnDeadlineLine1:
                "Hai scelto il <b>pagamento alla scadenza</b> come soluzione di pagamento.",
            paySingleInstallmentPlanOnDeadlineLine2:
                "Ti verrà addebitato il totale a pagare il giorno della scadenza.",
            payMultipleInstallmentsPlanOnDeadlineLine1:
                "Hai scelto il <b>pagamento delle rate alla scadenza</b> come soluzione di pagamento.",
            payMultipleInstallmentsPlanOnDeadlineLine2:
                "I pagamenti delle rate ti verranno addebitati alle singole scadenze.",
            payMultipleInstallmentsPlanOnDeadlineLine3:
                "Sei sicuro di voler procedere?",
            payNowLine1:
                "Hai scelto il <b>pagamento immediato</b> come soluzione di pagamento.",
            payNowLine2:
                "Ti verrà addebitato il totale a pagare il giorno stesso in cui effettui il pagamento.",
            expiredInstallmentsInfo:
                "Gli importi scaduti ti verranno addebitati entro 24 ore.",
            abort: "Annulla",
            confirm: "Ho capito",
            next: "Avanti",
        },
        PaymentForm: {
            genericError: "Si è verificato un errore.",
            disabledPaymentRequestError:
                "Questa richiesta non è più disponibile perché è disabilitata.",
            expiredPaymentRequestError:
                "Questa richiesta non è più disponibile perché è scaduta.",
            firstTab: "Anteprima documenti",
            secondTab: "Soluzioni di pagamento",
            thirdTab: "Metodi di pagamento",
            DocumentsPreview: {
                title: "ANTEPRIMA DOCUMENTI",
                sentYouTheDocument: "ti ha inviato il seguente documento",
                seeDocuments: "Visualizza documenti",
                by: "da parte di",
                deadline: "Scadenza:",
                totalPaymentAmount: "Totale pagamento:",
                alreadySettled: "Già saldato:",
                totalRemaining: "Totale rimanente:",
                noAttachedDocuments:
                    "La richiesta non possiede documenti allegati.",
                noDocumentsPreviewAvailable:
                    "Non è possibile visualizzare l'anteprima dei documenti.",
                payTheRequestToSeeDocuments:
                    "I documenti allegati saranno disponibili solo dopo l'avvenuto pagamento della richiesta.",
                proceedWithPaymentToViewBlockedDocuments:
                    "Alcuni documenti allegati saranno disponibili solo dopo l'avvenuto pagamento della richiesta.",
            },
            PaymentPlans: {
                title: "SOLUZIONE DI PAGAMENTO",
                payNow: "Paga subito",
                payNowInfoTooltip:
                    "L'importo selezionato ti verrà addebitato oggi",
                onHoldTooltip: "Pagamento in corso",
                paymentPlans: {
                    payTotalAmount: "Paga il totale",
                    payTotalAmountOnDeadline: "Paga il totale alla scadenza",
                    payTotalAmountDueDate: "Entro il {dueDate}",
                    payTotalAmountOnDueDate: "Scadenza: {dueDate}",
                    payInInstallments: "Paga le rate",
                    payInInstallmentsOnDeadline: "Paga le rate alla scadenza",
                    payInInstallmentsInfo:
                        "Le rate selezionate ti verranno addebitate al momento del pagamento",
                    payInInstallmentsonDeadlineInfo:
                        "I pagamenti delle rate ti verranno addebitati alle singole scadenze",
                },
                installments: {
                    installment: "Rata - {dueDate} - {amount}",
                },
            },
            PaymentMethods: {
                title: "METODI DI PAGAMENTO",
                noAvailablePaymentMethod:
                    "Non ci sono metodi di pagamento disponibili per l'importo di pagamento scelto.",
                notAvailableWithOnDeadlinePayment:
                    "Non disponibile con pagamento alla scadenza.",
                paymentMethods: {
                    creditDebitCard: "Carta di credito/debito",
                    payPal: "PayPal",
                    bankDirectDebit: "IBAN (addebito diretto)",
                    instantBankTransfer: "Bonifico istantaneo",
                },
            },
        },
        PrivacyCookiePolicyFooter: {
            privacyPolicy: "Privacy Policy",
            cookiePolicy: "Cookie",
        },
        PrivacyCookiePolicyMenu: {
            privacyPolicy: "Privacy Policy",
            cookiePolicy: "Cookie",
        },
        ResizeWrapper: {
            resizeScreenOrChangeOrientation:
                "Dimensioni dello schermo non supportate: ingrandisci la finestra del browser o cambia orientamento del dispositivo.",
        },
        Summary: {
            summary: "RIEPILOGO",
            paidDocumentMessage:
                "<b>Il documento è stato già pagato:</b> chiudi la pagina per uscire",
            externalPaidDocumentMessage:
                "<b>Pagamento in sospeso:</b> in attesa di una conferma del fornitore per la validazione del pagamento.",
            scheduledPayDocumentMessage:
                "<b>Pagamento alla scadenza:</b> prossima scadenza al {deadline}",
            paymentOnHold:
                "<b>Pagamento in corso:</b> è in corso un tentativo di pagamento per questa richiesta.",
            next: "Avanti",
            proceedToPayment: "Procedi al pagamento",
            alreadyPaid: "Pagamento già effettuato",
            totalToPay: "Totale a pagare",
            totalRemaining: "Totale rimanente",
            details: "Dettagli",
            AttachedDocuments: {
                attachedDocuments: "Documenti allegati",
                downloadBoundToPayment:
                    "Potrai scaricare il documento solo dopo aver concluso il pagamento.",
            },
            SummaryBox: {
                deadline: "Scadenza:",
                nextInstallmentDeadline: "Scadenza della prossima rata:",
                totalPaymentAmount: "Totale pagamento:",
                alreadySettled: "Già saldato:",
                expired: "Scaduto:",
                totalRemaining: "Totale rimanente:",
            },
        },
        Tabs: {
            step: "Step {number}",
        },
    },
    views: {
        NotFound: {
            notFoundError: "Page not found.",
        },
        Payment: {
            waitTrasnferToSecurePaymentSite:
                "Stai per essere trasferito sul sito di pagamento sicuro. Attendi qualche secondo.",
        },
        ThankYouPage: {
            loading: "Caricamento...",
            error: "Si è verificato un errore.",
        },
    },
});
